// Turn a raw enum key into a human-readable label as a LAST-RESORT fallback,
// used when an enum fact has no `enum_labels` entry for the value being
// rendered. The canonical label always comes from `enum_labels` (server- or
// config-provided); this only kicks in for keys that slipped through — e.g. a
// system/interaction document_type (`notes_meetings_transcripts`) that isn't in
// the org's configured `document_types`, which would otherwise render as the
// raw snake_case key in the Subtype cell.
//
// `notes_meetings_transcripts` -> "Notes Meetings Transcripts"
// `fund_fact_sheet`            -> "Fund Fact Sheet"
export function humanizeEnumKey(key: string): string {
  return key
    .split(/[_\s]+/)
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
